export default "__VITE_ASSET__kZ3AZhiE__"